module.exports = __webpack_public_path__ + "static/media/Event-Carousels-Adventure.1f1b1f2b.jpg";